import { render, staticRenderFns } from "./tour.vue?vue&type=template&id=7fe6aca1"
import script from "./tour.vue?vue&type=script&lang=js"
export * from "./tour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports